import { FC, PropsWithChildren, createContext, useContext } from 'react';

const LocalStorageContext = createContext<any>({});

const LocalStorageProvider: FC<PropsWithChildren> = ({ children }) => {
  const saveLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  const getLocalStorage = (key: string): any | null => {
    const item = localStorage.getItem(key);
    if (!item) return null;
    try {
      return JSON.parse(item);
    } catch {
      return null;
    }
  };

  const removeFromLocalStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  return (
    <LocalStorageContext.Provider
      value={{
        saveLocalStorage,
        getLocalStorage,
        removeFromLocalStorage,
      }}
    >
      {children}
    </LocalStorageContext.Provider>
  );
};

interface LocalStorageContextData {
  saveLocalStorage: (key: string, value: any) => void;
  getLocalStorage: (key: string) => any | null;
  removeFromLocalStorage: (key: string) => void;
}

const useLocalStorageContext = (): LocalStorageContextData => useContext(LocalStorageContext);

export { LocalStorageProvider, useLocalStorageContext };
